import { render, staticRenderFns } from "./serviceCreat.vue?vue&type=template&id=396d32d7&scoped=true"
import script from "./serviceCreat.vue?vue&type=script&lang=js"
export * from "./serviceCreat.vue?vue&type=script&lang=js"
import style0 from "./serviceCreat.vue?vue&type=style&index=0&id=396d32d7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396d32d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396d32d7')) {
      api.createRecord('396d32d7', component.options)
    } else {
      api.reload('396d32d7', component.options)
    }
    module.hot.accept("./serviceCreat.vue?vue&type=template&id=396d32d7&scoped=true", function () {
      api.rerender('396d32d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/service/serviceCreat.vue"
export default component.exports